var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfilelinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1378_8110)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 4,
    width: 19,
    height: 17,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 2.25V21.75C0.75 22.575 1.425 23.25 2.25 23.25H21.75C22.575 23.25 23.25 22.575 23.25 21.75V2.25C23.25 1.425 22.575 0.75 21.75 0.75H2.25C1.425 0.75 0.75 1.425 0.75 2.25ZM7.1625 19.5H4.5V9.15H7.1625V19.5ZM5.85 7.0875C5.1 7.0875 4.5 6.525 4.5 5.8125C4.5 5.1 5.1 4.5375 5.85 4.5375C6.6 4.5375 7.2 5.1 7.2 5.8125C7.1625 6.525 6.5625 7.0875 5.85 7.0875ZM19.5 19.5H16.8375V14.325C16.8375 13.2375 16.8 12.525 16.6875 12.1875C16.575 11.85 16.3875 11.625 16.1625 11.4375C15.9 11.25 15.6 11.175 15.2625 11.175C14.8125 11.175 14.4 11.2875 14.0625 11.55C13.6875 11.8125 13.4625 12.15 13.3125 12.5625C13.1625 12.975 13.125 13.7625 13.125 14.8875V19.5H9.9V9.15H12.5625V10.6875C13.4625 9.525 14.625 8.925 16.0125 8.925C16.6125 8.925 17.175 9.0375 17.7 9.2625C18.1875 9.4875 18.6 9.75 18.8625 10.0875C19.125 10.425 19.3125 10.8 19.3875 11.25C19.5 11.6625 19.5375 12.3 19.5375 13.0875V19.5H19.5Z",
    fill: "#0077B5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1378_8110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilelinkedin);
export default __webpack_public_path__ + "static/media/profilelinkedin.8357d7c949a7aff161db4ca7126c1590.svg";
export { ForwardRef as ReactComponent };